// extracted by mini-css-extract-plugin
module.exports = {"detail":"index_detail_1PJKq","text":"index_text_X2XuG","textHidden":"index_textHidden_mLQjj","contentBox":"index_contentBox_1cVWn","boxTitle":"index_boxTitle_1bJyX"};